import {
  Input, TemplateRef, Directive
} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[csTemplate]'
})
export class CsTemplate {
  @Input('csTemplate') type: string; // header | body

  constructor(public template: TemplateRef<any>) {
  }

  getType(): string {
    return this.type;
  }
}
